// extracted by mini-css-extract-plugin
export var caretAnchor = "_w3-0";
export var dropdownContent = "_w3-1";